/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ContraceptionType } from 'app/shared/model/enumerations/contraception-type.model';

export interface ISexualHistory {
  id?: string;
  solo?: boolean | null;
  partner?: boolean | null;
  currMethod?: string | null;
  currMethodSatisfaction?: string | null;
  pastMethodHistory?: string | null;
  sexuallyActive?: boolean | null;
  activeNumPartners?: number | null;
  newPartnerInThreeMonths?: boolean | null;
  contraception?: keyof typeof ContraceptionType | null;
  historyOfSexualAbuse?: boolean | null;
  abuseComments?: string | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<ISexualHistory> = {
  solo: false,
  partner: false,
  sexuallyActive: false,
  newPartnerInThreeMonths: false,
  historyOfSexualAbuse: false,
  active: false,
  draft: false,
};
